import React, { useState } from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import { apiRequest } from "./api/requestHelper";
import config from "../src/config/app.json";
import Modal from "react-modal";
import { useRouter } from "next/router";
import Preview from "../src/components/Preview";
import useFetchData from "../src/hooks/useFecthData";
import NewFeatureAlert from "../src/components/NewFeatureAlert";

Modal.setAppElement("#__next");

const HomeHeroComponent = dynamic(() =>
  import("../src/containers/HomeHeroSection")
);
const HomeTemplateListingComponent = dynamic(() =>
  import("../src/containers/HomeTemplateListingSection")
);

const appUrl = config["TEMPLATEURLS"][config["TEMPLATEURLS"]["current"]];
const apiUrl = config["APIURIS"][config["APIURIS"]["current"]];
const appConfigUrl = config["APPURLS"][config["APPURLS"]["current"]];

function HomePage({ templatesData, searchData, searchTags, seoData }) {
  const router = useRouter();
  const { title, keywords, meta_description, og_image } = seoData[0]["_source"];
  const { modalData } = useFetchData();
  const [showFeatureAlert, setShowFeatureAlert] = useState(true);

  function handleCloseFeatureAlert() {
    setShowFeatureAlert(false);
  }

  return (
    <>
      <Head>
        <title>
          {Object.keys(modalData).length > 0
            ? modalData["design"]["name_en"]
            : title}
        </title>
        <meta property="og:title" content={title} />
        <meta
          property="og:image"
          content={`${appConfigUrl}landing/og/${og_image}`}
        />
        <meta
          property="og:image:url"
          content={`${appConfigUrl}landing/og/${og_image}`}
        />
        <meta property="og:image:width" content={"140"} />
        <meta property="og:image:height" content={"140"} />
        <meta property="og:image:type" content={"image/jpeg"} />
        <meta name="keywords" content={keywords} />
        <meta name="description" content={meta_description} />
        <link rel="canonical" href={`${appUrl}/templates${router.asPath}`} />
        <meta
          property="og:url"
          content={`${appConfigUrl}landing/og/${og_image}`}
        />
        <meta property="og:description" content={meta_description} />
      </Head>
      {templatesData && searchData && (
        <>
          <HomeHeroComponent searchData={searchData} searchTags={searchTags} />
          <HomeTemplateListingComponent
            data={templatesData}
            searchData={searchData}
          />
        </>
      )}
      <Modal
        isOpen={!!router.query.templateId}
        onRequestClose={() => router.push("/", undefined, { shallow: true })}
        className="modal"
        overlayClassName="overlay"
      >
        <Preview data={modalData} allData={templatesData} closeLink={"/"} />
      </Modal>
      {/* {showFeatureAlert && (
        <NewFeatureAlert handleCloseFeatureAlert={handleCloseFeatureAlert} />
      )} */}
    </>
  );
}

export default React.memo(HomePage);

export async function getServerSideProps() {
  const { data } = await apiRequest("post", `${apiUrl}dynamic/`);
  if (
    !data["data"] ||
    !data["data"]["usecasedata"] ||
    !data["data"]["design_category"] ||
    !data["data"]["search_tags"] ||
    !data["data"]["seo_data"]
  ) {
    return {
      notFound: true,
    };
  }

  const templatesData = data["data"]["usecasedata"];
  const searchData = data["data"]["design_category"];
  const searchTags = data["data"]["search_tags"];
  const seoData = data["data"]["seo_data"];

  return {
    props: { templatesData, searchData, searchTags, seoData },
  };
}
